import { atom, useAtom } from "jotai";
import { atomFamily, atomWithStorage } from "jotai/utils";
import deepEqual from "fast-deep-equal";

import { StringTransform } from "interfaces/data-files/data-file-create";

import { fileColumns } from "./file-api";

interface Spec {
  fileId: string;
  column: string;
}

export const stringTransform = atomFamily(
  ({ fileId, column }: Spec) =>
    atomWithStorage<StringTransform["treatment"] | "as-is">(
      `data-files/string-transform/${fileId}/${column}`,
      "as-is"
    ),
  deepEqual
);

export const fileStringTransforms = atomFamily((fileId: string) =>
  atom((get) => {
    const columns = get(fileColumns(fileId));
    return columns
      .map((c) => ({
        column: c,
        treatment: get(stringTransform({ fileId, column: c })),
      }))
      .filter(
        ({ treatment }) => treatment && treatment !== "as-is"
      ) as StringTransform[];
  })
);

export const useColumnStringTransform = (fileId: string, column: string) =>
  useAtom(stringTransform({ fileId, column }));
